import React, { useContext, useEffect, useState } from "react"
import Form from "../components/Forms/Form"
import Header from "../components/Header"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"
import { Context } from "../store/store"
import ReceiptUpload from "../components/receipt/ReceiptUpload"
import Popup from "../components/elements/Popup"

const Home: React.FC = () => {
	const { dispatch } = useContext(Context)

	const [showPopup, setShowPopup] = useState<boolean>(false)
	useEffect(() => {
		if (process.env.NODE_ENV === "production") {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth",
			})
		}
	}, [])
	return (
		<PromoSoonOverHandler>
			<Header />

			<div className="js-sogehts  bg-black relative z-0">
				<img
					src={"/images/sogehtsFlower.png"}
					alt="Blume als Symbol für die Einfachheit der Teilnahme"
					className="hidden sm:block absolute left-[75%] top-[4rem] w-[7.1%] "
				/>
				<h2 className="h2 -mt-1 sm:-mt-2">So einfach geht’s ...</h2>

				<div className="text-center pt-5 pb-5 sm:pb-7">
					<svg
						className="inline-block w-[45px] sm:w-[59px] h-[43px] sm:h-[60px] "
						width="59"
						height="60"
						viewBox="0 0 59 60"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M0.459266 41.6162C0.459266 41.6162 -1.49739 26.5748 2.66666 12.5409C6.83072 -1.49445 19.2945 0.0502763 19.2945 0.0502763C19.2945 0.0502763 38.779 0.265195 45.634 2.30991C52.1219 4.24567 56.465 5.05759 57.5919 18.6169C58.5112 29.6882 58.5963 35.3552 56.5053 45.6593C55.8859 48.71 52.9786 56.9441 39.7148 57.4068C26.451 57.8694 15.1514 56.5142 9.44407 54.368C1.31297 51.3114 0.459266 41.6162 0.459266 41.6162Z"
							fill="#FFF079"
						/>
						<path
							d="M33.4241 44H29.3401V20.0115C27.6635 21.2153 24.0953 22.505 22.6336 22.7199V19.4527C25.9009 18.5069 28.8242 16.5293 30.3288 14.9387H33.4241V44Z"
							fill="#252525"
						/>
					</svg>
				</div>

				<p className="text-white text-[20px] sm:text-[25px] text-center pb-6 sm:pb-10 px-4">
					Kaufe 1 Aktionsprodukt in deiner
					<img
						src={"/images/dm.png"}
						alt="dm Filiale"
						className="w-[45px] sm:w-[71px] h-auto inline-block mx-2"
					/>
					Filiale*.
				</p>

				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/step1.png"} />
					<img
						src={"/images/step1-mobile.png"}
						className="mx-auto w-full max-w-[1030px] px-6 sm:px-0 block "
						alt="Drei einfache Schritte: Kaufen, hochladen und gewinnen"
					/>
				</picture>

				<p className="text-white text-[13px]  text-center pt-6  sm:pt-1 pb-7 sm:pb-12">
					*Der Onlinekauf ist von der Aktion ausgeschlossen.
					<br /> Aktionszeitraum vom 06.05. bis 10.06.2026.
				</p>

				<div className="text-center pb-4">
					<svg
						className="inline-block w-[45px] sm:w-[59px] h-[43px] sm:h-[60px]"
						width="59"
						height="60"
						viewBox="0 0 59 60"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M0.459266 41.6162C0.459266 41.6162 -1.49739 26.5748 2.66666 12.5409C6.83072 -1.49445 19.2945 0.0502763 19.2945 0.0502763C19.2945 0.0502763 38.779 0.265195 45.634 2.30991C52.1219 4.24567 56.465 5.05759 57.5919 18.6169C58.5112 29.6882 58.5963 35.3552 56.5053 45.6593C55.8859 48.71 52.9786 56.9441 39.7148 57.4068C26.451 57.8694 15.1514 56.5142 9.44407 54.368C1.31297 51.3114 0.459266 41.6162 0.459266 41.6162Z"
							fill="#FFF079"
						/>
						<path
							d="M40.0234 44H18.3134V43.785C18.3134 38.8412 21.4086 34.4992 28.3301 30.2862C33.6608 27.0619 35.1655 25.9442 35.1655 22.8489C35.1655 20.3555 33.5319 17.7331 29.1469 17.7331C25.4927 17.7331 23.3002 19.7966 22.6124 23.7087H18.6143C19.0442 18.2489 22.9563 14.3368 29.2758 14.3368C35.9393 14.3368 39.3355 18.2489 39.3355 22.8059C39.3355 27.7068 36.6271 29.4693 31.2104 32.6936C26.9114 35.316 23.9451 37.8524 23.1712 40.5178H40.6252L40.0234 44Z"
							fill="#252525"
						/>
					</svg>
				</div>

				<p className=" text-center text-white text-[20px] sm:text-[25px] sm:pb-10 px-6 leading-[25px] sm:leading-normal">
					Lade hier deinen Kassenbon hoch
				</p>

				<svg
					className="block sm:hidden mt-7 mx-auto"
					width="54"
					height="49"
					viewBox="0 0 54 49"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M45.9615 28.5093C45.7191 28.2399 45.3296 28.1566 44.9987 28.3042L40.3025 30.3667C39.7194 23.2295 36.2776 16.0644 30.3206 9.52502C25.5904 4.32952 21.0008 1.41393 20.7561 1.28021L19.4346 0.55717C19.0285 0.334005 18.5766 0.459976 18.3487 0.86913L17.5619 2.28221C17.3759 2.61854 17.416 3.02704 17.6937 3.28979C17.8094 3.40078 29.1643 14.4416 30.0342 30.9683L24.2077 29.9295C23.8798 29.8711 23.54 30.0125 23.3493 30.2925C23.1587 30.5725 23.1518 30.9352 23.3315 31.2188L28.9977 40.1915L34.0246 47.7704C34.0991 47.8839 34.2013 47.9766 34.3162 48.0383C34.4459 48.1103 34.5956 48.1474 34.7484 48.1422C35.0408 48.1318 35.3068 47.9704 35.4585 47.721L40.1039 39.8546L46.0598 29.4893C46.2413 29.172 46.2009 28.7766 45.9615 28.5093Z"
						fill="#FFF079"
					/>
				</svg>

				<div className="px-4 sm:px-0 pt-5 sm:pt-0">
					<div className="relative mx-auto block w-full max-w-[780px] border-[5px] border-dotted border-yellow  px-[20px] sm:px-[100px]  py-[27px]   text-center  -mt-2 bg-[#4d5252]">
						<img
							src={"/images/bonsample.png"}
							alt="Beispiel eines Kassenbons"
							className="hidden sm:block absolute left-0 top-0 w-full max-w-[203px] -translate-x-1/2  -translate-y-[120px]"
							onClick={() => {
								setShowPopup(true)
							}}
						/>

						<div className="relative z-10">
							<svg
								className="absolute left-1/2 -top-4 ml-[143px] hidden md:block"
								width="82"
								height="84"
								viewBox="0 0 82 84"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<mask id="mask0_43_496" maskUnits="userSpaceOnUse" x="0" y="0" width="82" height="84">
									<path
										d="M38.5136 83.5385L0 52.1126L42.5222 0L81.0358 31.4259L38.5136 83.5385Z"
										fill="white"
									/>
								</mask>
								<g mask="url(#mask0_43_496)">
									<path
										d="M30.8449 72.2593C31.3171 71.8945 31.5083 71.2696 31.316 70.7146L28.6391 62.8426C40.3163 62.6794 52.4486 57.8658 63.9253 48.8886C73.043 41.7607 78.4371 34.6105 78.6894 34.2269L80.0534 32.1553C80.4741 31.5187 80.3343 30.7693 79.7024 30.3531L77.5198 28.9167C77.0001 28.5769 76.3308 28.5972 75.8642 29.0203C75.6673 29.1965 56.1046 46.4649 29.1341 46.0607L31.6571 36.6902C31.7989 36.1629 31.6179 35.5941 31.1904 35.253C30.7629 34.9118 30.1747 34.8606 29.6882 35.122L14.3007 43.3576L1.26894 50.7061C1.07391 50.8149 0.908639 50.9709 0.791873 51.1512C0.656358 51.3545 0.57471 51.5941 0.561124 51.8433C0.536088 52.3204 0.76023 52.7713 1.14348 53.0457L13.2556 61.4743L29.2388 72.3115C29.7282 72.6419 30.3763 72.6196 30.8449 72.2593Z"
										fill="#FFF079"
									/>
								</g>
							</svg>

							<ReceiptUpload dispatch={dispatch} />
						</div>
					</div>
				</div>

				<button
					className="px-4 sm:px-0 text-center   text-[13px] pt-11 sm:pt-5 underline text-white sm:hidden relative w-full"
					onClick={() => setShowPopup(true)}
					type="button"
				>
					<svg
						className="absolute left-6 top-6"
						width="45"
						height="48"
						viewBox="0 0 45 48"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<mask id="mask0_6254_860" maskUnits="userSpaceOnUse" x="0" y="0" width="45" height="48">
							<path
								d="M22.3713 47.4571L44.8135 31.1459L22.5345 0.242897L0.092351 16.554L22.3713 47.4571Z"
								fill="white"
							/>
						</mask>
						<g mask="url(#mask0_6254_860)">
							<path
								d="M26.9843 41.3801C26.7307 41.1575 26.6418 40.7985 26.7653 40.4927L28.4889 36.1543C21.9635 35.6393 15.3175 32.4875 9.15796 27.0136C4.26436 22.667 1.45371 18.4429 1.32368 18.2176L0.620548 17.001C0.403589 16.6271 0.503361 16.2098 0.868731 15.9983L2.13062 15.268C2.431 15.0954 2.80471 15.1311 3.05348 15.3864C3.1585 15.4928 13.6012 25.9313 28.6952 26.6808L27.5541 21.3097C27.4899 21.0074 27.6076 20.6935 27.8564 20.5168C28.1053 20.3401 28.4357 20.3325 28.7002 20.4974L37.0681 25.6952L44.1442 30.3078C44.2501 30.3762 44.338 30.4701 44.3981 30.5759C44.4681 30.6954 44.5068 30.8333 44.5072 30.9742C44.5075 31.244 44.3692 31.4899 44.147 31.6306L37.131 35.9407L27.8809 41.4677C27.5978 41.6362 27.2359 41.6001 26.9843 41.3801Z"
								fill="white"
							/>
						</g>
					</svg>
					Beispiel Kassenbon anzeigen
				</button>

				{showPopup && (
					<Popup
						close={() => {
							setShowPopup(false)
						}}
					>
						<img
							src={"/images/bonsample-nozoom.png"}
							alt="Beispiel Kassenbon"
							className="  w-full max-w-[503px] mx-auto "
						/>
					</Popup>
				)}

				<div className="text-center pt-8 sm:pt-14 pb-3 sm:pb-9">
					<svg
						className="inline-block  w-[45px] sm:w-[59px] h-[43px] sm:h-[60px]"
						width="59"
						height="59"
						viewBox="0 0 59 59"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M0.459266 40.448C0.459266 40.448 -1.49739 25.8289 2.66666 12.1889C6.83072 -1.4525 19.2945 0.0488651 19.2945 0.0488651C19.2945 0.0488651 38.779 0.257751 45.634 2.24507C52.1219 4.1265 56.465 4.91562 57.5919 18.0943C58.5112 28.8548 58.5963 34.3628 56.5053 44.3777C55.8859 47.3427 52.9786 55.3457 39.7148 55.7954C26.451 56.245 15.1514 54.9279 9.44407 52.8419C1.31297 49.8711 0.459266 40.448 0.459266 40.448Z"
							fill="#FFF079"
						/>
						<path
							d="M22.5078 21.161H18.4667C18.9826 17.8078 21.648 13.3368 28.9563 13.3368C36.0497 13.3368 38.973 17.2489 38.973 21.118C38.973 24.9872 36.2216 26.5778 34.502 27.0507V27.1367C36.6515 27.6525 40.2197 29.6731 40.2197 34.488C40.2197 39.8617 36.1357 43.6019 29.0423 43.6019C21.648 43.6019 18.4237 39.4748 17.6929 35.1758H21.863C22.6368 38.1851 25.1302 40.2056 29.2143 40.2056C32.9544 40.2056 35.9207 38.486 35.9207 34.402C35.9207 31.0917 33.6422 29.0712 28.9563 29.0712H26.7208V25.589H28.5694C33.2553 25.589 34.674 23.9554 34.674 21.29C34.674 18.8826 32.9544 16.6901 28.8273 16.6901C24.7433 16.6901 23.1527 18.7536 22.5078 21.161Z"
							fill="#252525"
						/>
					</svg>
				</div>

				<p className="text-center text-white text-[20px] sm:text-[25px] px-6">
					Trage hier deine persönlichen Daten ein:
				</p>

				<div className="px-4 sm:px-0">
					<Form />
				</div>

				<p className="text-center font-Fields text-[35px] sm:text-[72px] text-yellow mt-2 sm:mt-5  pb-4 sm:pb-7">
					Viel Glück.
				</p>
			</div>
		</PromoSoonOverHandler>
	)
}
export default Home
